import { reducer, RequestState } from 'commons/src/reducers/requestReducer';

const initialStateObject: RequestState = {
    loading: false,
    error: undefined,
};

export enum PublicRequestType {
    FetchPublicDashboard = 'FETCH_PUBLIC_DASHBOARD',
    FetchPublicDashboardTiles = 'FETCH_PUBLIC_DASHBOARD_TILES',
}

export type PublicRequestStore = {
    [K in PublicRequestType]: RequestState;
};

const initialStore: PublicRequestStore = {
    [PublicRequestType.FetchPublicDashboard]: initialStateObject,
    [PublicRequestType.FetchPublicDashboardTiles]: initialStateObject,
};

export default reducer(initialStore);
